import { User } from "./user";

export class Icd10Code {
  code!: string;
  short_description!: string;
  long_description!: string;
  status!: string;
  date_deleted?: number | null;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  constructor(data: any) {
    this.code = data.code;
    this.short_description = data.short_description;
    this.long_description = data.long_description;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
